var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-input',_vm._g(_vm._b({ref:"el",attrs:{"size":"large","type":"email"}},'a-input',Object.assign({}, _vm.$attrs, _vm.$props),false),_vm.listeners))}
var staticRenderFns = []

export { render, staticRenderFns }